<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green">
                    <v-flex slot="header">
                        <v-layout row>
                            <span
                                class="subheading font-weight-light mr-3"
                                style="align-self: center"
                                >Greetings:</span
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                small
                                class="mr-2 my-0"
                                style="background-color: #fff; color: #4caf50 !important"
                                @click="openUploadGreeting()"
                            >
                                Upload Greeting
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-data-table
                        :headers="headers"
                        :items="greetings"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <td>
                                <v-tooltip top dark>
                                    <template #activator="{ on }" dark>
                                        <v-icon
                                            v-on="on"
                                            dark
                                            :color="
                                                getStatusIconColor(item.status)
                                            "
                                            >{{
                                                getStatusIcon(item.status)
                                            }}</v-icon
                                        >
                                    </template>
                                    <span dark>{{ item.Status }}</span>
                                </v-tooltip>
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ item.name }}
                            </td>
                            <td class="font-weight-regular">
                                {{ item.fromPhone }}
                            </td>

                            <td class="text-xs-left font-weight-regular">
                                {{ item.timestamp }}
                            </td>
                            <td>
                                <audio
                                    controls
                                    :src="item.recordingUrl"
                                ></audio>
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                {{ item.uploadedOn }}
                            </td>
                            <td class="text-xs-left font-weight-regular">
                                <v-btn
                                    @click="openDeleteGreeting(item)"
                                    color="success"
                                    flat
                                    icon
                                    ><v-icon>mdi-close-circle</v-icon></v-btn
                                >
                            </td>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="deleteDialog" max-width="400px">
            <v-card class="pa-3">
                <div class="headline mb-3">Delete Greeting</div>

                <audio controls :src="greetingToDelete.recordingUrl"></audio>

                <v-card-actions class="mt-2 mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteGreeting()"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="uploadGreetingDialog" max-width="400px">
            <v-card class="pa-3">
                <div class="headline mb-2">Upload Greeting</div>

                <v-btn
                    small
                    class="mr-2 mt-3"
                    color="success"
                    :loading="uploadingGreeting"
                    @click="pickGreetingFile()"
                >
                    Upload
                    <v-icon right dark>mdi-cloud-upload</v-icon>
                </v-btn>
                <input
                    type="file"
                    style="display: none"
                    ref="greetingFiles"
                    accept=".mp3"
                    @change="onGreetingFilePicked($event)"
                />
                <div v-if="greeting.files.length" class="pt-2 mb-3 ml-2">
                    {{ greeting.files[0].name }}
                </div>
                <template>
                    <v-menu
                        v-model="datePickerMenu"
                        :close-on-content-click="true"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        class="date-picker-menu"
                        max-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="greeting.date"
                                label="Date"
                                class="mx-2 text-black"
                                readonly
                                color="green"
                                style="max-width: 200px; background-color: #fff;"
                                v-on="on"
                                hide-details
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            style="color: black !important;"
                            v-model="greeting.date"
                        ></v-date-picker>
                    </v-menu>
                    <v-layout row wrap class="my-3">
                        <v-flex md12 lg6>
                            <v-time-picker
                                v-model="greeting.time"
                                color="green lighten-1"
                            ></v-time-picker>
                        </v-flex>
                    </v-layout>
                </template>
                <div class="my-3 text-danger" v-if="greeting.error">
                    {{ greeting.error }}
                </div>
                <v-card-actions class="mt-2 mr-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="uploadGreetingDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";
import { toISOLocal } from "../utils/helpers.js";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 10,
                page: 1,
            },

            headers: [
                { value: "Status", text: "Status" },
                { value: "name", text: "Name" },
                { value: "fromPhone", text: "From Number" },
                { value: "timestamp", text: "Time" },
                { value: "recordingUrl", text: "Recording" },
                { value: "uploadedOn", text: "Uploaded On" },
                { value: "", text: "" },
            ],

            deleteDialog: false,
            greetingToDelete: {},

            greetings: [],
            uploading: false,
            uploadingGreeting: false,
            uploadGreetingDialog: false,
            processing: false,
            datePickerMenu: false,
            greeting: {
                files: [],
                date: toISOLocal(new Date(moment())).substr(0, 10),
                time: null,
                error: "",
            },
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.pagination.totalItems / this.pagination.rowsPerPage,
                  )
                : 0;
        },
    },
    created() {
        this.greeting.time = this.getCurrentTime();

        this.loadData();
    },
    methods: {
        // firebaseSetup() {
        //     const firebaseConfig = {
        //         apiKey: "Xs6kU5UjjL8n5LdLQJMGnWcaEietBLrj5U9FnpIb",
        //         authDomain: "broadcast-b7a56.firebaseapp.com",
        //         databaseURL: "https://broadcast-b7a56.firebaseio.com",
        //         projectId: "broadcast-b7a56",
        //     };

        //     // Initialize Firebase
        //     if (!firebase.apps.length) {
        //         firebase.initializeApp(firebaseConfig);
        //     }

        //     var database = firebase.database();
        //     var ref = firebase.database().ref("greetings");

        //     const greetingsRef = ref.orderByKey().limitToLast(100);

        //     greetingsRef.on(
        //         "value",
        //         (snapshot) => {
        //             const greetings = Object.values(snapshot.val()).map(
        //                 (message) => {
        //                     message.FromPhone = this.formatPhoneNumber(
        //                         message.FromPhone
        //                     );

        //                     message.Date = moment(message.Timestamp).format(
        //                         "LLL"
        //                     );

        //                     return message;
        //                 }
        //             );
        //             this.greetings = greetings.sort((a, b) => {
        //                 if (Date.parse(a.Timestamp) > Date.parse(b.Timestamp))
        //                     return -1;
        //                 if (Date.parse(a.Timestamp) < Date.parse(b.Timestamp))
        //                     return 1;
        //                 return 0;
        //             });

        //             this.pagination.totalItems = this.greetings.length;
        //         },
        //         function(error) {
        //             console.log("Error: " + error.code);
        //         }
        //     );

        //     ref.on("child_added", (data, prevChildKey) => {});
        // },
        getStatusIcon(status) {
            switch (status) {
                case "Completed":
                    return "mdi-check-circle";
                case "Pending":
                    return "mdi-clock";
            }
        },
        getStatusIconColor(status) {
            switch (status) {
                case "Completed":
                    return "success";
                case "Pending":
                    return "#fdb400";
            }
        },
        formatPhoneNumber(phoneNumberString) {
            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        async loadData() {
            const response = await this.$http.get(
                this.getDomain() + "/api/home/getGreetings",
            );

            this.pagination.totalItems = response.data.length;

            const now = new Date();

            this.greetings = response.data.map((a) => {
                a.timestamp = moment(a.timestamp).format("LLL");
                a.uploadedOn = a.uploadedOn
                    ? moment(a.uploadedOn).format("LLL")
                    : "";
                a.status =
                    new Date(a.timestamp) > now ? "Pending" : "Completed";

                return a;
            });
        },
        getDomain() {
            return window.location.host.includes("localhost")
                ? "https://localhost:44337"
                : "https://broadcastmessageswercber.azurewebsites.net";
        },
        openUploadGreeting() {
            this.greeting.files = [];
            this.uploadGreetingDialog = true;
        },
        pickGreetingFile() {
            this.$refs.greetingFiles.click();
        },
        pickAudioFile() {
            this.$refs.audioFiles.click();
        },
        getCurrentTime() {
            var now = new Date(); // get current date
            var hours = now.getHours(); // get hours from date
            var minutes = now.getMinutes(); // get minutes from date
            var seconds = now.getSeconds(); // get seconds from date

            // format hours to have 2 digits
            hours = ("0" + hours).slice(-2);
            // format minutes to have 2 digits
            minutes = ("0" + minutes).slice(-2);
            // format seconds to have 2 digits
            seconds = ("0" + seconds).slice(-2);

            var time = hours + ":" + minutes; // combine hours, minutes, and seconds with ":" in between
            return time; // output: 13:25:45
        },
        async onGreetingFilePicked(e) {
            this.uploadingGreeting = true;

            const files = e.target.files;

            if (!files) return;

            this.greeting.files = files;

            this.uploadingGreeting = false;
        },
        async save() {
            if (!this.greeting.time) {
                this.greeting.error = "Missing Time";
                return;
            }

            if (!this.greeting.date) {
                this.greeting.error = "Missing Date";
            }

            if (!this.greeting.files.length) {
                this.greeting.error = "Please Upload File";

                return;
            }

            this.greeting.error = "";

            var formData = new FormData();

            formData.append("file", this.greeting.files[0]);

            try {
                this.processing = true;

                const date = this.greeting.date + " " + this.greeting.time;

                await this.$http.post(
                    this.getDomain() +
                        "/api/home/UploadFile?type=greeting&user=" +
                        this.$store.state.user +
                        "&date=" +
                        date,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                this.processing = false;
                this.uploadGreetingDialog = false;
                this.loadData();
            } catch (e) {
                this.processing = false;
            }
        },
        openDeleteGreeting(item) {
            this.greetingToDelete = item;
            this.deleteDialog = true;
        },
        async deleteGreeting() {
            try {
                this.processing = true;

                await this.$http.post(
                    this.getDomain() +
                        "/api/home/DeleteGreeting?id=" +
                        this.greetingToDelete.id,
                );

                this.processing = false;
                this.deleteDialog = false;
                this.loadData();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}
.v-date-picker-table .v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
}
</style>
